import { register } from 'swiper/element/bundle';
import { Navigation, Pagination } from 'swiper/modules';
export default (function () {
  function initSwiper(swiperWrapper) {
    const swiperContainer = swiperWrapper.querySelector('swiper-container');

    const swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: false,
      centerInsufficientSlides: true,
      breakpoints: {
        601: {
          spaceBetween: 16,
        },
        906: {
          spaceBetween: 24,
        },
      },
      modules: [Navigation, Pagination],
      pagination: {
        clickable: true,
      },
      //injectStylesUrl isn't working
      injectStyles: [
        `
                :host {
                    --swiper-buttons-size: 40px;
                    --swiper-padding: 56px;
                    --swiper-pagination-bottom: calc(var(--swiper-padding) / 2);
                    --swiper-navigation-sides-offset: 2px;
                }

                :host .swiper-pagination {
                  display: flex;
                  gap: 8px;
                  width: calc(100% - (var(--swiper-buttons-size)*2) - 20px);
                   
                  @media (min-width: 601px) {
                      justify-content: flex-start;
                  }

                  .swiper-pagination-bullet {
                      width: 24px;
                      height: 8px;
                      border-radius: 8px;
                      background-color: var(--SysLightInversePrimary);
                      opacity: 1;
                      margin: 0;
                  }
                  .swiper-pagination-bullet-active {
                      background-color: var(--SysLightInverseSurface);
                      }
                  }
                `,
        `
                
                :host .swiper{
                  padding-bottom: var(--swiper-padding);
                }

                :host .swiper-button-prev, :host .swiper-button-next {
                    width: var(--swiper-buttons-size);
                    height: var(--swiper-buttons-size);
                    background-color: var(--SysLightPrimary);
                    border-radius: 50%;
                    display:flex;
                    align-items: center;
                    justify-content: center;
                    transition: background-color 0.5s ease-in-out;
                    opacity: 1;
                    color: var(--SysLightOnPrimary);
                    top: var(--swiper-navigation-top-offset);
                    transform: translateY(calc(var(--swiper-padding) / 2));
                    
                    &:hover {
                        opacity:0.8;
                        cursor:pointer;
                    }
                    &.swiper-button-disabled:hover {
                        opacity:1;
                        cursor:default;
                    }
                    svg {
                        width:14px;
                        height:14px;
                        fill: var(--White);
            
                    }
                }
                .swiper-button-lock  {
                    display: none;
                }
                :host .swiper-button-prev {
                    right: calc(var(--swiper-buttons-size) + 10px);
                    left: auto;

                    &.swiper-button-disabled {
                        background-color: var(--StateLayersLightOnSurfaceOpacity012);
                    }
                }
                :host .swiper-button-next {
                    &.swiper-button-disabled {
                        background-color: var(--StateLayersLightOnSurfaceOpacity012);
                    }
                }
                    `,
      ],
    };
    Object.assign(swiperContainer, swiperOptions);
    swiperContainer.initialize();
  }

  function bindEvents() {
    register();

    const swiperWrappers = document.querySelectorAll('.swiper-wrap');

    swiperWrappers.forEach((swiperWrapper) => {
      initSwiper(swiperWrapper);
    });
  }

  function init() {
    bindEvents();
  }

  return {
    init: init,
  };
})();
